export default "__VITE_ASSET__dydxV0WK__"